import React, { useEffect, useState } from "react";
import { Input, Col, Row, Checkbox, Select, Card, Form, Upload } from "antd";
import axios from "axios";
import Title from "antd/lib/typography/Title";
import { uploadButton } from "components/UploadButton/UploadButton";
import ReactQuill from "react-quill";
import { Sector } from "interfaces/companies";
import NeedHelpIcon from "../NeedHelpIcon/NeedHelpIcon";

interface Props {
  setLogo: (file: File | null) => void;
  setCoverImage: (file: File | null) => void;
  logoPreview: string | null;
  coverImagePreview: string | null;
}

const StepAboutCompany: React.FC<Props> = ({ setLogo, setCoverImage, logoPreview, coverImagePreview }) => {
  const [sectors, setSectors] = useState<Sector[]>([]);

  useEffect(() => {
    axios.get<Sector[]>("/companies/sectors/").then(response => {
      setSectors(response.data);
    });
  }, []);

  const CheckBoxSectors = sectors.map(sector => {
    if (!sector.name) return null;
    return (
      <Col key={sector.id} lg={4} md={6} sm={8} xs={12}>
        <Checkbox key={sector.id} value={sector.id}>
          {sector.name}
        </Checkbox>
      </Col>
    );
  });

  return (
    <>
      <Card style={{ width: "100%" }}>
        <Row style={{ justifyContent: "space-between", width: "100%" }}>
          <Col>
            <Title level={3}>Informasjon om bedriften</Title>
          </Col>
          <Col>
            <NeedHelpIcon />
          </Col>
        </Row>

        <Form.Item
          label="Bedriftsnavn"
          name="name"
          rules={[
            {
              required: true,
              message: "Skriv inn navn på bedriften",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Bransje(r)"
          name="sectors"
          required
          rules={[
            {
              validator(_, value) {
                if (!value || value.length === 0) {
                  return Promise.reject(new Error("Velg minst én bransje bedriften din tilhører"));
                }
                if (value.length > 4) {
                  return Promise.reject(new Error("Velg maks fire bransjer bedriften din tilhører"));
                }
                return Promise.resolve();
              },
            },
          ]}
          style={{ paddingBottom: "1.5em" }}
        >
          <Checkbox.Group>
            <Row style={{ minHeight: "66px" }}>{CheckBoxSectors}</Row>
          </Checkbox.Group>
        </Form.Item>

        <Form.Item
          label="Antall ansatte"
          name="size"
          rules={[
            {
              required: true,
              message: "Oppgi antall ansatte",
            },
          ]}
        >
          <Select
            placeholder="Velg antall ansatte"
            options={[
              { label: "1-10", value: 1 },
              { label: "11-50", value: 2 },
              { label: "51-200", value: 3 },
              { label: "201-500", value: 4 },
              { label: "501-1000", value: 5 },
              { label: "1001-5000", value: 6 },
              { label: "5001-10 000", value: 7 },
              { label: "10 001+", value: 8 },
            ]}
          />
        </Form.Item>

        <Form.Item label="Beskrivelse" name="description">
          <ReactQuill theme="snow" />
        </Form.Item>
        <Row gutter={24}>
          {/* TODO make function to save company logo and cover picture */}
          <Col span={12}>
            <Form.Item
              name="logo"
              label="Logo"
              rules={[
                {
                  required: true,
                  message: "Last opp bedriftslogo",
                },
              ]}
            >
              <Upload
                listType="picture-card"
                beforeUpload={file => {
                  setLogo(file);
                  return false;
                }}
                onRemove={() => {
                  setLogo(null);
                }}
                fileList={
                  logoPreview
                    ? [
                        {
                          uid: "-1",
                          name: "Logo",
                          status: "done",
                          url: logoPreview,
                        },
                      ]
                    : []
                }
              >
                {uploadButton}
              </Upload>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Coverbilde" name="logo_wide">
              <Upload
                listType="picture-card"
                beforeUpload={file => {
                  setCoverImage(file);
                  return false;
                }}
                onRemove={() => {
                  setCoverImage(null);
                }}
                fileList={
                  coverImagePreview
                    ? [
                        {
                          uid: "-1",
                          name: "Coverbilde",
                          status: "done",
                          url: coverImagePreview,
                        },
                      ]
                    : []
                }
              >
                {uploadButton}
              </Upload>
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default StepAboutCompany;
